import { Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { FirebaseService } from '@shared/services/firebase.service';
import { LoaderService } from '@shared/services/loader.service';
import { AppRoutes } from '@shared/const/app.routes';

@Component({
  selector: 'app-header',
  imports: [RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  private readonly _dialog = inject(MatDialog);
  private readonly _firebaseService = inject(FirebaseService);
  private readonly _router = inject(Router);
  private loaderService = inject(LoaderService);
  showOptions = input<boolean>(true);

  routes = AppRoutes;

  openDialogCloseSession(): void {
    const dialogRef = this._dialog.open(ModalConfirmComponent, {
      width: '582px',
      panelClass: 'custom-alert-dialog',
      disableClose: true,
      data: {
        message: '¿Estás seguro de que quieres cerrar sesión?',
        information: '',
        icon: 'error',
        backgroundColor: '#FFE8EA',
        iconColor: '#b00020',
        confirmButtonColor: '#577778',
        confirmTextColor: '#ffffff',
        cancelButtonColor: '#577778',
        confirmText: 'Sí, cerrar sesión',
        cancelText: 'No, cancelar',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._signOut();
      }
    });
  }

  async _signOut(): Promise<void> {
    this.loaderService.show();

    try {
      await this._firebaseService.logout();
    } finally {
      this.loaderService.hide();
      this._goToHome();
    }
  }

  _goToHome(): void {
    this._router.navigateByUrl('');
  }
}
